/*
 * Brotherhood+ i18n bootstrap
 * -----------------------------------------------------------------------------
 * App is currently English-only. The other locales stay bundled so we can flip
 * localization back on later without a rebuild.
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import pt from './locales/pt.json';

export const SUPPORTED_LANGS = [
  { code: 'en', label: 'English', flag: '\uD83C\uDDFA\uD83C\uDDF8' },
];

// Wipe any previously-persisted language selection so users are back on English.
try { localStorage.removeItem('bp_lang'); } catch { /* ignore */ }

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      fr: { translation: fr },
      pt: { translation: pt },
    },
    lng: 'en',
    fallbackLng: 'en',
    supportedLngs: ['en'],
    interpolation: { escapeValue: false },
    returnEmptyString: false,
  });

export default i18n;
